import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { getValueOrDash } from "../../../../utils/helpers";
import { getUser } from "../../../../services/authService";
import { updateTransporterData, updateAggregateTransporterData, update5MTransporterData, getTransporterData } from "../../../../services/TransporterDataService";


const TransporterEditableCell = ({
  value: initialValue,
  row: { original, subRows },
  column: { id },
  allowToEdit,
  // setCopyData
}) => {
  const [value, setValue] = useState(initialValue);
  const user = getUser();
  const [oldvalue,setoldvalue] = useState(original["Container_Number"]);

  const onChange = (e) => {
    setValue(e.target.value);
  };


  // var copyValueArray = []
  // function pasteFunction(event) {
  //   event.clipboardData.items[0].getAsString((text) => {
  //     let lines = text.split('\n');
  //     // let i = 1;
  //     lines.forEach((line) => {
  //       let cell = line.split('\t');
  //       // let newCat = {
  //       //   DataOf: cell[0],
  //       //   Vehicle_No: cell[1],
  //       //   FLEETX_LR_No: cell[2],
  //       // };
  //       // let key = `cat${i}`;
  //       copyValueArray.push({
  //         DataOf: cell[0],
  //         Vehicle_No: cell[1],
  //         FLEETX_LR_No: cell[2],
  //       })
  //       setCopyData(copyValueArray);
  //       // i++;
  //     });
  //   });
  // }

  async function onBlur() {
    if (original[id] !== value) {
      try {
        if(original.DataOf === "TRACTOR"){
          updateTransporterData({
            Id: `${original["TransporterDataId"]}`,
            columnName: `${id}`,
            prevVal:  getValueOrDash(original[id]),
            value: value,
            UserId: user.uid,
          });
        }
        if(original.DataOf === "AGGREGATE"){
          updateAggregateTransporterData({
            Id: `${original["TransporterDataId"]}`,
            columnName: `${id}`,
            prevVal:  getValueOrDash(original[id]),
            value: value,
            UserId: user.uid,
          });
        }
        if(original.DataOf === "5M"){
          update5MTransporterData({
            Id: `${original["TransporterDataId"]}`,
            columnName: `${id}`,
            prevVal:  getValueOrDash(original[id]),
            value: value,
            UserId: user.uid,
          });
        }
        toast.success(`"${id}" column updated with "${value}"`);
      } catch (error) {
        toast.error("Unable to update column")
      }
    }
  }

  async function onBlurcontainernumber() {
    const regex = /^[A-Za-z]{4}\d{7}$/
    if (original[id] !== value && regex.test(value)) {
      try {
        if(original.DataOf === "TRACTOR"){
          setoldvalue(value)
          updateTransporterData({
            Id: `${original["TransporterDataId"]}`,
            columnName: `${id}`,
            prevVal:  getValueOrDash(original[id]),
            value: value,
            UserId: user.uid,
          });
          
        }
        if(original.DataOf === "AGGREGATE"){
          setoldvalue(value)
          updateAggregateTransporterData({
            Id: `${original["TransporterDataId"]}`,
            columnName: `${id}`,
            prevVal:  getValueOrDash(original[id]),
            value: value,
            UserId: user.uid,
          });
    
        }
        if(original.DataOf === "5M"){
          setoldvalue(value)
          update5MTransporterData({
            Id: `${original["TransporterDataId"]}`,
            columnName: `${id}`,
            prevVal:  getValueOrDash(original[id]),
            value: value,
            UserId: user.uid,
          });
        }
        toast.success(`"${id}" column updated with "${value}"`);
      } catch (error) {
        toast.error("Unable to update column")
      }
    }
    else {
      if(original[id] !== value){
        setValue(oldvalue);
        toast.warn("Container number format is incorrect")
      }
      }
  }

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  if (
    id === "Vehicle_No" ||
    id === "FLEETX_LR_No" ||
    id === "Customer" ||
    id === "Customer_No" ||
    id === "Consignee" ||
    id === "Consignee_name" ||
    id === "Clearance" ||
    id === "Empty_yard" ||
    id === "Movement_type" ||
    id === "Seal_No" ||
    id === "Driver_No"
  ) {
    return (
      <input
        type="text"
        className="table_input"
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        name={id}
        disabled = {id === "DataOf" || id === "Date" || id === "Booking_Number" || id === "Carrier" || id === "Container_Type" || !allowToEdit}
      />
    );
  }
  else{
    return (
      <input
        type="text"
        className="table_input"
        value={value}
        onChange={onChange}
        onBlur={id==="Container_Number" ? onBlurcontainernumber : onBlur}
        name={id}
        disabled = {id === "DataOf" || id === "Date" || id === "Booking_Number" || id === "Carrier" || id === "Container_Type" || !allowToEdit}
      />
    );
  }
};

export const defaultTransporterColumn = {
  Cell: TransporterEditableCell,
};
